/* ------------------------------------------------------------------
   Dulhansdiary — cart drawer
   Self-contained. Does not depend on theme internals, so it survives
   Opal/Editions theme updates. If anything throws, it falls back to
   the native form POST (the theme's original behaviour).
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var cfg = window.CartDrawerConfig || {};
  var routes = (window.Theme && window.Theme.routes) || {};
  var ADD = routes.cart_add_url || '/cart/add';
  var CHANGE = routes.cart_change_url || '/cart/change';
  var CART_URL = routes.cart_url || '/cart';
  var moneyFormat = (window.Theme && window.Theme.moneyFormat) || '${{amount}}';

  var root, panel, itemsEl, subtotalEl, shipBarEl, countEls, overlay;
  var lastFocus = null;
  var busy = false;

  /* ---------- money ---------- */
  function commafy(n, decimals, thousand, decimal) {
    if (isNaN(n) || n === null) return '0';
    n = (n / 100).toFixed(decimals);
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousand || ','));
    return parts[1] ? whole + (decimal || '.') + parts[1] : whole;
  }
  function money(cents) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = moneyFormat.match(placeholder);
    var name = match ? match[1] : 'amount';
    switch (name) {
      case 'amount': value = commafy(cents, 2); break;
      case 'amount_no_decimals': value = commafy(cents, 0); break;
      case 'amount_with_comma_separator': value = commafy(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = commafy(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = commafy(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = commafy(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = commafy(cents, 2, ' ', '.'); break;
      default: value = commafy(cents, 2);
    }
    return moneyFormat.replace(placeholder, value);
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function sized(url, w) {
    if (!url) return '';
    try { return url.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_' + w + 'x$1$2'); }
    catch (e) { return url; }
  }

  /* ---------- dom ---------- */
  function grab() {
    root = document.querySelector('[data-cart-drawer]');
    if (!root) return false;
    panel = root.querySelector('[data-cd-panel]');
    itemsEl = root.querySelector('[data-cd-items]');
    subtotalEl = root.querySelector('[data-cd-subtotal]');
    shipBarEl = root.querySelector('[data-cd-shipping]');
    overlay = root.querySelector('[data-cd-overlay]');
    return true;
  }

  function setHeaderCount(n) {
    countEls = document.querySelectorAll('[data-header-cart-count]');
    for (var i = 0; i < countEls.length; i++) {
      countEls[i].textContent = n > 0 ? '(' + n + ')' : '';
    }
  }

  /* ---------- free shipping bar ---------- */
  function renderShipping(cart) {
    if (!shipBarEl) return;
    var threshold = cfg.freeShippingThreshold;
    if (!threshold || threshold <= 0) { shipBarEl.innerHTML = ''; shipBarEl.hidden = true; return; }
    shipBarEl.hidden = false;
    var total = cart.total_price;
    var remaining = threshold - total;
    var pct = Math.max(0, Math.min(100, (total / threshold) * 100));
    var msg = remaining > 0
      ? (cfg.shippingAway || "You're {{ amount }} away from free shipping").replace('{{ amount }}', '<strong>' + money(remaining) + '</strong>')
      : (cfg.shippingUnlocked || "You've unlocked free shipping");
    shipBarEl.innerHTML =
      '<p class="cd-ship__msg">' + msg + '</p>' +
      '<div class="cd-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '">' +
        '<span class="cd-ship__fill" style="width:' + pct + '%"></span>' +
      '</div>';
  }

  /* ---------- render ---------- */
  function renderCart(cart) {
    setHeaderCount(cart.item_count);
    if (subtotalEl) subtotalEl.innerHTML = money(cart.total_price);

    var footer = root.querySelector('[data-cd-footer]');
    var empty = root.querySelector('[data-cd-empty]');

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '';
      if (empty) empty.hidden = false;
      if (footer) footer.hidden = true;
      if (shipBarEl) shipBarEl.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;

    var html = '';
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var props = '';
      if (it.properties) {
        for (var k in it.properties) {
          if (!Object.prototype.hasOwnProperty.call(it.properties, k)) continue;
          if (k.charAt(0) === '_' || !it.properties[k]) continue;
          props += '<li>' + esc(k) + ': ' + esc(it.properties[k]) + '</li>';
        }
      }
      var priceHtml = it.original_line_price > it.final_line_price
        ? '<s class="cd-item__was">' + money(it.original_line_price) + '</s> <span class="cd-item__now">' + money(it.final_line_price) + '</span>'
        : '<span class="cd-item__now">' + money(it.final_line_price) + '</span>';

      html +=
        '<li class="cd-item" data-key="' + esc(it.key) + '">' +
          '<a class="cd-item__media" href="' + esc(it.url) + '" tabindex="-1">' +
            (it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="" loading="lazy" width="72" height="90">' : '<span class="cd-item__noimg"></span>') +
          '</a>' +
          '<div class="cd-item__body">' +
            '<a class="cd-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="cd-item__variant">' + esc(it.variant_title) + '</p>' : '') +
            (props ? '<ul class="cd-item__props">' + props + '</ul>' : '') +
            '<div class="cd-item__row">' +
              '<div class="cd-qty">' +
                '<button type="button" class="cd-qty__btn" data-cd-minus aria-label="' + esc(cfg.decrease || 'Decrease quantity') + '">&minus;</button>' +
                '<input class="cd-qty__input" type="number" inputmode="numeric" min="0" value="' + it.quantity + '" data-cd-qty aria-label="' + esc(cfg.quantity || 'Quantity') + '">' +
                '<button type="button" class="cd-qty__btn" data-cd-plus aria-label="' + esc(cfg.increase || 'Increase quantity') + '">+</button>' +
              '</div>' +
              '<span class="cd-item__price">' + priceHtml + '</span>' +
            '</div>' +
            '<button type="button" class="cd-item__remove" data-cd-remove>' + esc(cfg.remove || 'Remove') + '</button>' +
          '</div>' +
        '</li>';
    }
    itemsEl.innerHTML = html;
    renderShipping(cart);
  }

  /* ---------- network ---------- */
  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    if (busy) return Promise.resolve();
    busy = true;
    root.classList.add('cd--busy');
    return fetch(CHANGE + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () { window.location.href = CART_URL; })
      .then(function () { busy = false; root.classList.remove('cd--busy'); });
  }

  /* ---------- open / close ---------- */
  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('cd--open');
    document.documentElement.classList.add('cd-locked');
    var close = root.querySelector('[data-cd-close]');
    if (close) close.focus();
  }
  function close() {
    if (!root) return;
    root.classList.remove('cd--open');
    document.documentElement.classList.remove('cd-locked');
    window.setTimeout(function () { root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- add to cart ---------- */
  function isAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  function handleAdd(form, submitter) {
    var btn = submitter || form.querySelector('[data-product-atc]');
    if (btn) btn.classList.add('cd-loading');

    var data = new FormData(form);

    fetch(ADD + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: data
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw body;
          return body;
        });
      })
      .then(function () { return getCart(); })
      .then(function (cart) {
        renderCart(cart);
        open();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function (err) {
        var msg = err && (err.description || err.message);
        var target = form.querySelector('[data-response-message]');
        if (msg && target) {
          target.textContent = msg;
          target.classList.add('cd-error');
        } else {
          form.submit();
        }
      })
      .then(function () { if (btn) btn.classList.remove('cd-loading'); });
  }

  /* ---------- wire up ---------- */
  function init() {
    if (!grab()) return;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!isAddToCartForm(form)) return;
      if (e.submitter && e.submitter.closest && e.submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      handleAdd(form, e.submitter);
    }, true);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-product-atc]');
      if (!btn) return;
      var form = btn.closest('form');
      if (!isAddToCartForm(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      handleAdd(form, btn);
    }, true);

    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href$="/cart"], [data-cd-open]');
      if (!link) return;
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      getCart().then(function (cart) { renderCart(cart); open(); });
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cd-close]') || t.closest('[data-cd-overlay]')) { close(); return; }

      var item = t.closest('.cd-item');
      if (!item) return;
      var key = item.getAttribute('data-key');
      var input = item.querySelector('[data-cd-qty]');
      var qty = parseInt(input && input.value, 10) || 0;

      if (t.closest('[data-cd-remove]')) { changeLine(key, 0); return; }
      if (t.closest('[data-cd-minus]')) { changeLine(key, Math.max(0, qty - 1)); return; }
      if (t.closest('[data-cd-plus]')) { changeLine(key, qty + 1); return; }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('[data-cd-qty]');
      if (!input) return;
      var item = input.closest('.cd-item');
      changeLine(item.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('cd--open')) close();
    });

    getCart().then(function (cart) { setHeaderCount(cart.item_count); }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
